import layout from './MultiLink.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MultiLinkViewModelType from '@/ViewModels/Controls/MultiLinkViewModel';
import LabelType from '@/Controls/Label';

export default class MultiLink extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;

    public constructor(private viewModel: MultiLinkViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl);

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'multilink',

            locator: this.viewModel.locator,

            technicalName: this.viewModel.technicalName,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    var styles = [];

                    styles.push('default');

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () =>{
                    var states = [];

                    if (this.viewModel.isActive() === true) {
                        states.push('active');
                    } else {
                        states.push('inactive');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    if (!this.viewModel.onClick.isEmpty) {
                        states.push('hasClickListener');
                    }

                    return states;
                }
            }),

            click: () => {
                if (this.isDisposed === false && this.viewModel.isEnabled() === true) {
                    this.viewModel.onClick();
                }
            }
        });
    }
}

ComponentManager.setControl('MultiLink', MultiLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');